module.exports = __webpack_public_path__ + "img/friend.7863d8d6.png";